import type {FullInfo} from '@rocket-ui/lk-api';
import {RU_OKSM_CODE, normalizeRegistrationOksmCode} from 'features/registration/model';

export type ProfileGender = 'male' | 'female';

const GENDER_LABELS: Record<ProfileGender, string> = {
	male: 'Мужской',
	female: 'Женский',
};

export function formatProfileGender(gender: string | null | undefined): string {
	if (gender === 'male' || gender === 'female') {
		return GENDER_LABELS[gender];
	}

	return '—';
}

export function formatProfilePhone(phone: string | null | undefined): string {
	if (!phone) {
		return '—';
	}

	const digits = phone.replace(/\D/g, '');
	const normalized =
		digits.startsWith('7') || digits.startsWith('8') ? digits.slice(1, 11) : digits.slice(0, 10);

	if (normalized.length !== 10) {
		return phone.trim() || '—';
	}

	return `+ 7 (${normalized.slice(0, 3)}) ${normalized.slice(3, 6)}-${normalized.slice(6, 8)}-${normalized.slice(8, 10)}`;
}

export function formatProfileText(value: string | null | undefined): string {
	const trimmed = value?.trim();

	return trimmed ? trimmed : '—';
}

function getOksmCodeFromFullInfo(
	fullInfo: FullInfo | undefined,
	field: 'citizenship' | 'residence',
): string | null {
	const value = fullInfo?.[field];

	if (!value || typeof value !== 'object') {
		return null;
	}

	const oksmCode = (value as {oksmCode?: string | null}).oksmCode;

	return typeof oksmCode === 'string' && oksmCode.trim() ? oksmCode : null;
}

export function getCitizenshipOksmCode(fullInfo: FullInfo | undefined): string | null {
	return getOksmCodeFromFullInfo(fullInfo, 'citizenship');
}

export function getResidenceOksmCode(fullInfo: FullInfo | undefined): string | null {
	return getOksmCodeFromFullInfo(fullInfo, 'residence');
}

export function isRussiaCitizenship(oksmCode: string | null): boolean {
	return normalizeRegistrationOksmCode(oksmCode) === RU_OKSM_CODE;
}
